import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";


const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!email) {
      setError("Please enter your email address.");
      return;
    }
    if (!password) {
      setError("Please enter your password.");
      return;
    }
    // Basic email format check
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    // Simulate login (replace with real logic)
    setError("");
    // ...existing login logic...
  };

  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden bg-white text-gray-800" style={{ fontFamily: 'Public Sans, sans-serif' }}>
      <Header />
      <main className="flex flex-1 items-center justify-center py-12 px-4 sm:px-6 lg:px-8" role="main">
        <div className="w-full max-w-md space-y-8">
          <div>
            <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-800">Welcome back</h2>
            <p className="mt-2 text-center text-sm text-gray-600">Login to access your client dashboard.</p>
          </div>
          <form className="mt-8 space-y-6" aria-label="Login form" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label className="sr-only" htmlFor="email-address">Email address</label>
                <input
                  autoComplete="email"
                  className="relative block w-full appearance-none rounded-t-md border border-gray-300 px-3 py-3 text-gray-800 placeholder-gray-400 focus:z-10 focus:border-blue-600 focus:outline-none focus:ring-blue-600 sm:text-sm bg-white"
                  id="email-address"
                  name="email"
                  placeholder="Email address"
                  required
                  type="email"
                  aria-label="Email address"
                  aria-required="true"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label className="sr-only" htmlFor="password">Password</label>
                <input
                  autoComplete="current-password"
                  className="relative block w-full appearance-none rounded-b-md border border-gray-300 px-3 py-3 text-gray-800 placeholder-gray-400 focus:z-10 focus:border-blue-600 focus:outline-none focus:ring-blue-600 sm:text-sm bg-white"
                  id="password"
                  name="password"
                  placeholder="Password"
                  required
                  type="password"
                  aria-label="Password"
                  aria-required="true"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
            </div>
            {error && (
              <div className="text-red-600 text-sm text-center" role="alert">{error}</div>
            )}
            <div className="flex items-center justify-between">
              <div className="text-sm">
                <a className="font-medium text-[var(--primary-color)] hover:text-[var(--primary-color)]/90" href="#">Forgot your password?</a>
              </div>
            </div>
            <div>
              <button className="group relative flex w-full justify-center rounded-md border border-transparent bg-[var(--primary-color)] py-3 px-4 text-sm font-semibold text-white hover:bg-[var(--primary-color)]/90 focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2" type="submit" aria-label="Login">Login</button>
            </div>
          </form>
          <p className="mt-4 text-center text-sm text-gray-600">New to Needal? <a className="font-medium text-blue-600 hover:text-blue-700" href="#">Create an account</a></p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Login;
